import { Box, Grid, Typography } from "@mui/material";
import { City, Country } from "country-state-city";
import { useEffect, useState } from "react";
import Select from "react-select";
import PropTypes from "prop-types";

const CountrySelect = ({
  label,
  country,
  city,
  onPaisChange,
  onCityChange,
  disabled = true,
}) => {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);

  useEffect(() => {
    const allCountries = Country.getAllCountries().map((c) => ({
      value: c.isoCode,
      label: c.name,
    }));
    setCountries(allCountries);
  }, []);

  useEffect(() => {
    if (country) {
      const found = countries.find((c) => c.value === country) || null;
      setSelectedCountry(found);
    } else {
      setSelectedCountry(null);
    }
  }, [country, countries]);

  useEffect(() => {
    if (selectedCountry) {
      const cityList = City.getCitiesOfCountry(selectedCountry.value).map((ct) => ({
        value: ct.name,
        label: ct.name,
      }));
      setCities(cityList);
    } else {
      setCities([]);
      setSelectedCity(null);
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (city) {
      const found = cities.find((c) => c.value === city) || null;
      setSelectedCity(found);
    } else {
      setSelectedCity(null);
    }
  }, [city, cities]);

  const handleCountryChange = (opt) => {
    if (opt) {
      onPaisChange(opt.value);
      setSelectedCountry(opt);
      onCityChange("");
      setSelectedCity(null);
    } else {
      onPaisChange("");
      setSelectedCountry(null);
      onCityChange("");
      setSelectedCity(null);
    }
  };

  const handleCityChange = (opt) => {
    if (opt) {
      onCityChange(opt.value);
      setSelectedCity(opt);
    } else {
      onCityChange("");
      setSelectedCity(null);
    }
  };


  const labelColor = "#567D8C";;

 const selectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: state.isDisabled ? "#F5F5F5" : "#fff",
    borderRadius: 10,
    border: `1px solid ${
      state.isDisabled ? "#E0E0E0" : state.isFocused ? "#567D8C" : "#E0E0E0"
    }`,
    boxShadow: "none",
    minHeight: 42,
    paddingLeft: 6,
    paddingRight: 6,
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    opacity: state.isDisabled ? 0.85 : 1,
    "&:hover": {
      borderColor: state.isDisabled ? "#E0E0E0" : "#CFCFCF",
    },
  }),

  valueContainer: (base) => ({
    ...base,
    padding: "2px 8px",
  }),

  singleValue: (base, state) => ({
    ...base,
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: 500,
    color: state.isDisabled ? "#00000061" : "#1D3D4D",
  }),

  placeholder: (base, state) => ({
    ...base,
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: 500,
    color: state.isDisabled ? "#00000061" : "#00000099",
  }),

  input: (base, state) => ({
    ...base,
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: 500,
    color: state.isDisabled ? "#00000061" : "#1D3D4D",
  }),

  indicatorSeparator: () => ({ display: "none" }),

  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isDisabled ? "#00000061" : "#1D3D4D",
    "&:hover": { color: state.isDisabled ? "#00000061" : "#1D3D4D" },
  }),

  clearIndicator: (base, state) => ({
    ...base,
    color: state.isDisabled ? "#00000061" : "#1D3D4D",
    "&:hover": { color: state.isDisabled ? "#00000061" : "#1D3D4D" },
  }),

  menu: (base) => ({
    ...base,
    borderRadius: 10,
    overflow: "hidden",
    zIndex: 9999,
    fontFamily: "Montserrat",
  }),

  option: (base, state) => ({
    ...base,
    fontFamily: "Montserrat",
    fontSize: "14px",
    backgroundColor: state.isSelected
      ? "rgba(29, 61, 77, 0.12)"
      : state.isFocused
      ? "rgba(86, 125, 140, 0.12)"
      : "#fff",
    color: "#111",
    cursor: "pointer",
  }),
};



  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontFamily: "Montserrat",
              fontSize: "20px",
              fontWeight: "bold",
              color: labelColor,
            }}
          >
            {label}
          </Typography>

          <Select
            options={countries}
            value={selectedCountry}
            onChange={handleCountryChange}
            isDisabled={disabled}
            placeholder="Selecciona un país"
            styles={selectStyles}
            isClearable
            
          />
        </Grid>

        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography
            sx={{
              fontFamily: "Montserrat",
              fontSize: "20px",
              fontWeight: "bold",
              color: labelColor,
            }}
          >
            Ciudad
          </Typography>

          <Select
            options={cities}
            value={selectedCity}
            onChange={handleCityChange}
            isDisabled={!selectedCountry }
            placeholder="Selecciona una ciudad"
            styles={selectStyles}
            isClearable
          />
        </Grid>
      </Grid>
    </Box>
  );
};

CountrySelect.propTypes = {
  label: PropTypes.string.isRequired,
  country: PropTypes.string,     
  city: PropTypes.string,         
  onPaisChange: PropTypes.func.isRequired,
  onCityChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default CountrySelect;
